/* =============================================================
   LA SMOLE · REFONTE 2026 — comportements
   - en-tête mobile compact quand on descend, complet quand on remonte
   - bouton « retour en haut »
   - pied de page en accordéons sur mobile
   ============================================================= */
(function () {
  'use strict';
  if (window.SmoleRefonte) return;
  window.SmoleRefonte = true;

  var html = document.documentElement;
  var mobile = window.matchMedia('(max-width: 749px)');
  var lastY = window.scrollY, ticking = false, top;

  function drawerOpen() {
    return !!document.querySelector('header-drawer > details[open]');
  }

  function onScroll() {
    var y = window.scrollY;
    var down = y > lastY + 4, up = y < lastY - 4;
    if (mobile.matches && !drawerOpen()) {
      if (down && y > 120) html.classList.add('smole-compact');
      else if (up || y <= 120) html.classList.remove('smole-compact');
    } else {
      html.classList.remove('smole-compact');
    }
    if (top) top.classList.toggle('is-on', y > window.innerHeight * 0.9);
    if (down || up) lastY = y;
    ticking = false;
  }

  function init() {
    top = document.createElement('button');
    top.type = 'button';
    top.className = 'smole-top';
    top.setAttribute('aria-label', (window.SmoleI18n && window.SmoleI18n.top) || 'Retour en haut de page');
    top.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path d="M12 19V5M5 12l7-7 7 7"/></svg>';
    top.addEventListener('click', function () {
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
    });
    document.body.appendChild(top);

    /* Pied de page : accordéons sur mobile, tout ouvert sur ordinateur */
    document.querySelectorAll('.soleil-footer__col').forEach(function (col) {
      var h = col.querySelector(':scope > h4'), list = col.querySelector(':scope > ul');
      if (!h || !list) return;
      col.setAttribute('data-smole-acc', '');
      h.setAttribute('role', 'button');
      h.setAttribute('tabindex', '0');
      h.setAttribute('aria-expanded', 'false');
      function toggle() {
        var open = col.classList.toggle('is-open');
        h.setAttribute('aria-expanded', open ? 'true' : 'false');
      }
      h.addEventListener('click', function () { if (mobile.matches) toggle(); });
      h.addEventListener('keydown', function (e) {
        if (mobile.matches && (e.key === 'Enter' || e.key === ' ')) { e.preventDefault(); toggle(); }
      });
    });

    window.addEventListener('scroll', function () {
      if (!ticking) { window.requestAnimationFrame(onScroll); ticking = true; }
    }, { passive: true });
    mobile.addEventListener('change', onScroll);
    onScroll();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
